import React, {useState, useEffect, useCallback} from 'react';
import { authEventBus, AUTH_EVENTS } from '../../utils/AuthEvents';
import {Link, useLocation, useNavigate } from 'react-router-dom';
import {CatalogoLayout} from '../../containers/Layout';
import NavBarStore from '../modules/NavBarStore';
import {SideBarStore} from '../../shop/modules/SideBarStore';
import CheckOutBar from '../../shop/modules/CheckOutBar';
import useAuth from '../../components/hooks/hooks-e-commerce/useAuth';

import { ToastContainer } from '../../contexts/ToastNotification';
import { useLoginModal, LoginModalProvider } from '../../contexts/LoginModalContext';
import { LoginModalWrapper } from '../../components/modules/Wrapper/LoginModalWrapper';
//import { VerificationListener } from '../../contexts/VerificationListener';
//import { } from '../../contexts/LoginModalContext';
//import { showToast } from '../../contexts/ToastNotification';

import useCart from '../../components/hooks/hooks-e-commerce/useCart';
import Cart from '../../shop/components/images/iconstore/cartW50.png';
import User from '../../shop/components/images/iconstore/UtenteW50.png';
import Lenth from '../../shop/components/images/iconstore/lenteW50.png';
import CartHover from '../../shop/components/images/iconstore/cartOrangeW50.png';
import UserHover from '../../shop/components/images/iconstore/UtenteOranW50.png';
import LenthHover from '../../shop/components/images/iconstore/lenteOranW50.png';
import iconLogout from '../../shop/components/images/iconstore/iconLogoutW40.png'
import './shopstore.scss';

function ShopStoreContent() {
    const navigate = useNavigate();
    const { openLoginModal } = useLoginModal();
    
     // ✅ Ascolta i parametri URL per la verifica email
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const verified = urlParams.get('verified');
        const email = urlParams.get('email');
        
        if (verified === 'true' && email) {
            // Pulisci URL
            window.history.replaceState({}, document.title, window.location.pathname);
            
            console.log('📧 Verifica rilevata! Email:', email);
            
            // Apri modal login dopo 1 secondo
            setTimeout(() => {
                openLoginModal('login');
            }, 1000);
        }
    }, [navigate, openLoginModal]);

    return (
        <div className="store-layout">
            <SideBarStore />
            <CatalogoLayout />
        </div>
    )
}

// ✅ ShopStore principale
function ShopStore() {
    // reactJS hooks
    let location = useLocation();

    const [hiddenSidebar, setHiddenSideBar] = useState(false);
    const [hiddenComponent, setHiddenComponent] = useState(false);
    const [countCart, setCountCart] = useState(0)
    const [width, setWidth] = useState(0);
    const [newView, setNewView] = useState(false);
    const [navStoreHidden, setNavStoreHidden] = useState(false);
    const [hasCheckedAuth, setHasCheckedAuth] = useState(false);
    const [isIconHovered, setIsIconHovered] = useState({
            lenth: false,
            cart: false
        });

    const [isUserHovered, setIsUserHovered] = useState(false);

    //Custom hook    
    const {cart, subscribe, refreshCart} = useCart();

    const { 
            user, 
            isAuthenticated, 
            getCurrentUser,
            logout, 
            loading: authLoading,
            syncExternalAuth 
        } = useAuth();

    const { openLoginModal } = useLoginModal();

    const handleIsHovered = (value) => {
            if(value === 1) {
                setIsIconHovered({lenth: true});
            } else if(value === 2) {
                setIsIconHovered({cart: true});
            } 
        }
    
    const handleNoHovered = (value) => {
        if(value === 1) {
            setIsIconHovered({lenth: false})
        } else if(value === 2) {
            setIsIconHovered({cart: false});
        } 
    }

    // ✅ Gestisci resize
    const handleWidthResize = useCallback(() => {
        const newWidth = window.innerWidth;
        setWidth(newWidth);
        if (newWidth <= 800) {
            setNewView(false);
        } else {
            setNewView(newWidth <= 1100);  // Mode mobile si <= 1024px
            setNavStoreHidden(true);
        }
        setNavStoreHidden(newWidth > 1100);
        
    }, []);

    useEffect(() => {
        const isCheckout = location.pathname.includes('checkout');
        if(isCheckout) {
            setHiddenSideBar(true);
            setHiddenComponent(true); 
        } else {
            setHiddenSideBar(false);
            setHiddenComponent(false);
        } 
    }, [location]);

    // ✅ Ascolta evento di login per refresh carrello
    useEffect(() => {
        const handleLogin = () => {
            console.log('📢 [Header] Ricevuto evento login, refresho carrello');
            refreshCart();
        };
        
        const unsubscribe = authEventBus.subscribe(AUTH_EVENTS.LOGIN, handleLogin);
        
        return () => {
            unsubscribe();
        };
    }, [refreshCart]); 

     // ✅ Ascolta evento di logout per reset carrello
    useEffect(() => {
        const handleLogout = () => {
            console.log('📢 [Header] Ricevuto evento logout, refresho carrello');
            refreshCart();
            //showToast('👋 Logout effettuato con successo', 'info', 3000);
        };
        
        const unsubscribe = authEventBus.subscribe(AUTH_EVENTS.LOGOUT, handleLogout);
        
        
        return () => {
            unsubscribe();
        };
    }, [refreshCart]);

    // ✅ SOTTOSCRIVITI AGLI AGGIORNAMENTI
    useEffect(() => {
        // Subscribe agli aggiornamenti del carrello
        const unsubscribe = subscribe((updatedCart) => {
            //console.log('🛒 Header: Carrello aggiornato', updatedCart);
            setCountCart(updatedCart?.item_count || 0);
        });

        // Cleanup
        return unsubscribe;
    }, [subscribe]); 

    useEffect(() => {
        if (cart && cart.item_count !== undefined) {
            setCountCart(cart.item_count);

        } else {
            setCountCart(0);
        }
    }, [cart]);

    useEffect(() => {
        // Ascolta cambiamenti di autenticazione da altri componenti
        const unsubscribe = authEventBus.subscribe(
            AUTH_EVENTS.AUTH_CHANGED, 
            (data) => {
                //console.log('📢 NavBarStore riceve aggiornamento auth:', data);
                syncExternalAuth(data.user, data.isAuthenticated);
            }
        );

        const unsubscribeLogin = authEventBus.subscribe(
            AUTH_EVENTS.LOGIN,
            (userData) => {
                //console.log('📢 NavBarStore riceve login event');
                syncExternalAuth(userData, true);
            }
        );

        const unsubscribeLogout = authEventBus.subscribe(
            AUTH_EVENTS.LOGOUT,
            () => {
                //console.log('📢 NavBarStore riceve logout event');
                syncExternalAuth(null, false);
            }
        );

        const unsubscribeUpdate = authEventBus.subscribe(
            AUTH_EVENTS.USER_UPDATED,
            (userData) => {
                //console.log('📢 NavBarStore riceve user update');
                syncExternalAuth(userData, true);
            }
        );

        return () => {
            unsubscribe();
            unsubscribeLogin();
            unsubscribeLogout();
            unsubscribeUpdate();
        };
    }, [syncExternalAuth]);

     // ✅ Inizializza l'auth una volta sola al mount
    useEffect(() => {
        const checkAuth = async () => {
            if (!hasCheckedAuth) {
                //console.log('🔄 Header: Verifico autenticazione utente...');
                await getCurrentUser();
                setHasCheckedAuth(true);
            }
        };
        
        checkAuth();
    }, [getCurrentUser, hasCheckedAuth]);

    // ✅ Gestisci resize window
    useEffect(() => {
        window.addEventListener("resize", handleWidthResize);
        handleWidthResize();
        
        return () => {
            window.removeEventListener("resize", handleWidthResize);
        };
    }, [handleWidthResize, width]);

    if ((authLoading/*  && !hasCheckedAuth */)) {
        return <div className="header-loading">Caricamento...</div>;
    }

    return (
        <main>
            {newView && !hiddenComponent &&   
            <div className="store-top-bar__up">
                <div className="store-top-bar__info-user">
                    <span>Benvenuto ! </span> {isAuthenticated && <p> { user.nome ||' Utente'} </p>}
                    {isAuthenticated && <img src={iconLogout} alt="incon of logout" onClick={logout}/>}   
                </div>
                {newView &&
                <div className="top__bar-cmd">
                    {/* ✅ Mostra nome utente se loggato, altrimenti pulsante login */}
                    <div 
                        className="bar-cmd__link" 
                        onMouseEnter={() => setIsUserHovered(true)} 
                        onMouseLeave={() => setIsUserHovered(false)}  
                        onClick={() => openLoginModal('login')}
                    >
                        <img 
                            className={`hover-effects ${isUserHovered ? 'hovered' : ''}`} 
                            src={isUserHovered ? UserHover : User} 
                            alt="Accedi/Registrati" 
                        />
                    </div>
                    {/* Stesso modale, stesso comportamento */}
                    <Link to="/" className="bar-cmd__link" onMouseEnter={() => handleIsHovered(1)} onMouseLeave={() => handleNoHovered(1)}>
                        <img className={`hover-effects ${isIconHovered.lenth ? 'hovered' : ''}`} src={isIconHovered.lenth ? LenthHover : Lenth} alt="icon for lenth of search" /> 
                    </Link>
                    <div className="bar-cmd__cart">
                        <Link to="carrello" className="bar-cmd__link" onMouseEnter={() => handleIsHovered(2)} onMouseLeave={() => handleNoHovered(2)}>
                            <img className={`hover-effects ${isIconHovered.cart ? 'hovered' : ''}`} src={isIconHovered.cart ? CartHover : Cart} alt="icon for cart" />
                        </Link>
                        <div className="bar-cart__number">
                            <span>{countCart}</span>
                        </div>
                    </div>
                </div>}
            </div>}

            {!hiddenComponent && <div className="store-top-bar__info-delevery">
                <p>Sconto di 50% sulle spese di spedizione per tutta la regione dell'Abruzzo.</p>
            </div>}
            {navStoreHidden && <NavBarStore/>}
            {!hiddenSidebar ?
            (<LoginModalProvider>
                {/* <VerificationListener /> */}
                <ToastContainer />
                <ShopStoreContent />
                <LoginModalWrapper />
            </LoginModalProvider>
            ):(
                <div className="checkout-layout">
                    <ToastContainer />
                    <CheckOutBar />
                    <CatalogoLayout />
                </div>  
            )}
        </main>
    );
    
}

export default ShopStore;
